<script>
// import axios from '@/utils/axios';
import { useFollowupStore } from '@/stores/useFollowupStore'

export default {
    inject: ['setLoading'],
    data() {
        return {
            tableColumns: [
                { key: 'lead_name', label: 'Lead Name' },
                { key: 'mobile', label: 'Mobile' },
                { key: 'title', label: 'Title' },
                { key: 'status', label: 'Status' },
                { key: 'type', label: 'Type' },
                { key: 'followup_time', label: 'Followup Time' },
                { key: 'created_by', label: 'Created By' },
                { key: 'actions', label: 'Actions' },
            ],
            title: "CRM",
            text: "CRM",
            // text1: "Today's Followup (0)",
            // data: [],
            // loading: true,
        };
    },

    // async mounted() {
    //     this.loadFollowups();
    // },


    created() {
  this.followupStore = useFollowupStore()
  this.followupStore.loadFollowups()
},

    methods: {
        // async loadFollowups() {
        //     this.loading = true;
        //     try {
        //         const response = await axios.get('/reminders/my/created');
        //         this.data = response.data.data || [];
        //         this.text1 = `Today's Followup (${this.data.length})`;
        //     } catch (error) {
        //         this.$swalToast(error.message, 'error');
        //     } finally {
        //         this.loading = false;
        //     }
        // },
    },
};
</script>

<style scoped>
.l-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
}

.followup-status-badge {
    font-size: 10.5px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 20px;
    display: inline-block;
}
</style>

<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper">
        <div class="content">

            <!-- Breadcrumb -->
            <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                <breadcrumb :title="title" :text="text" :text1="`Today's Followup (${followupStore.count})`" />
            </div>

            <!-- Main Card -->
            <div class="card border-0 shadow-sm mb-0" style="border-radius:14px;">

                <div
                    class="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
                        Today's Followup
                        <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ followupStore.count }})</span>
                    </h5>
                    <button class="btn btn-sm btn-outline-primary" @click="followupStore.loadFollowups(true)">
                        <i class="ti ti-refresh me-1"></i>Refresh
                    </button>
                </div>

                <div class="card-body px-3 pt-2 pb-3" style="background:#f1f5f9;">

                    <app-table :columns="tableColumns" :rows="followupStore.list" :loading="followupStore._loadingPromise !== null" :skeleton-rows="10"
                        empty-text="No followups for today." empty-icon="ti ti-bell-off">

                        <!-- Lead Name -->
                        <template #lead_name="{ row }">
                            <div class="d-flex align-items-center gap-2" v-if="row.lead">
                                <div class="l-avatar"
                                    :style="{ background: `hsl(${((row.lead.name || 'A').charCodeAt(0) * 37) % 360}, 60%, 55%)` }">
                                    {{ (row.lead.name || '').charAt(0).toUpperCase() }}
                                </div>
                                <router-link :to="{ name: 'leads-details', params: { id: row.lead.id } }"
                                    style="font-weight:600; color:#0f172a; text-decoration:none;">
                                    {{ row.lead.name }}
                                </router-link>
                            </div>
                            <span v-else style="color:#cbd5e1;">—</span>
                        </template>

                        <!-- Mobile -->
                        <template #mobile="{ row }">
                            <span v-if="row.lead?.mobile"
                                style="font-size:12px; color:#64748b; display:flex; align-items:center; gap:5px;">
                                <i class="ti ti-phone" style="font-size:13px; color:#6366f1;"></i>
                                {{ row.lead.mobile }}
                            </span>
                            <span v-else style="color:#cbd5e1;">—</span>
                        </template>

                        <!-- Title -->
                        <template #title="{ row }">
                            <span style="font-weight:500;">{{ row.title }}</span>
                        </template>

                        <!-- Status -->
                        <template #status="{ row }">
                            <span class="followup-status-badge" :style="row.is_completed
                                ? 'background:#f0fdf4; color:#16a34a; border:1px solid #bbf7d0;'
                                : 'background:#fffbeb; color:#b45309; border:1px solid #fde68a;'">
                                {{ row.is_completed ? 'Completed' : row.status || 'Pending' }}
                            </span>
                        </template>

                        <!-- Type -->
                        <template #type="{ row }">
                            <span
                                style="font-size:11px; color:#475569; background:#f1f5f9; border:1px solid #e2e8f0; border-radius:20px; padding:2px 10px;">
                                {{ row.reminder_type }}
                            </span>
                        </template>

                        <!-- Followup Time -->
                        <template #followup_time="{ row }">
                            <span style="font-size:11.5px; color:#64748b;">
                                <i class="ti ti-clock-hour-3 me-1" style="font-size:12px;"></i>
                                {{ $formatDate(row.reminder_datetime, 'DD MMM YYYY, hh:mm a') }}
                            </span>
                        </template>

                        <!-- Created By -->
                        <template #created_by="{ row }">
                            <div class="d-flex align-items-center gap-2" v-if="row.creator">
                                <img v-if="row.creator?.image" :src="row.creator?.image_url" width="22" style="border-radius:50%;" />
                                <img v-else src="@/assets/img/profiles/avatar-12.jpg" width="22" style="border-radius:50%;" />
                                <span style="font-size:12px;">{{ row.creator?.name }}</span>
                            </div>
                        </template>

                        <!-- Actions -->
                        <template #actions="{ row }">
                            <router-link v-if="row.lead" :to="{ name: 'leads-details', params: { id: row.lead.id } }"
                                class="btn btn-sm btn-outline-primary" style="font-size:11px; padding:3px 10px;">
                                <i class="ti ti-eye me-1"></i>View Lead
                            </router-link>
                        </template>

                    </app-table>

                </div>
            </div>

        </div>
        <app-footer></app-footer>
    </div>
</template>